import React from 'react';
import { createPortal } from 'react-dom';

// Importamos el formulario unificado
import FormularioSiniestro from '../Formularios/FormularioSiniestro';

const ModalSiniestro = ({ show, onClose, onSuccess, poliza, clientData, initialData }) => {
  if (!show) return null;

  // Wrapper para manejar el éxito y cerrar el modal automáticamente
  const handleSuccess = (msg) => {
      onSuccess(msg); // Notificar al padre (CobranzaTab o SiniestrosTab)
      onClose();      // Cerrar modal
  };

  const title = initialData ? 'Editar Siniestro' : 'Cargar Nuevo Siniestro';

  return createPortal(
    <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-[1010] flex items-center justify-center p-4 backdrop-blur-sm transition-opacity">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl h-auto max-h-[95vh] flex flex-col overflow-hidden animate-fade-in border border-gray-100">
        
        {/* HEADER DEL MODAL (Diseño estilo Endoso adaptado a Rojo) */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-red-50/50 shrink-0">
            <div className="flex items-center gap-3">
                {/* Icono temático */}
                <span className="bg-red-100 text-red-600 p-2 rounded-lg shrink-0">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
                </span>
                
                {/* Título y Subtítulo */}
                <div>
                    <h3 className="text-xl font-bold text-gray-800 leading-none">{title}</h3>
                    {poliza && (
                        <p className="text-xs text-red-800/70 font-bold mt-1 tracking-wide">
                            Póliza: {poliza.nPoliza} • {poliza.compania}
                        </p>
                    )}
                </div>
            </div>

            {/* Botón Cerrar */}
            <button 
                onClick={onClose} 
                className="text-gray-400 hover:text-gray-600 transition-colors p-1.5 rounded-full hover:bg-white/80"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
        </div>

        {/* CUERPO: Renderizamos el Editor Unificado */}
        <div className="overflow-y-auto flex-grow bg-white custom-scrollbar">
            <FormularioSiniestro 
                poliza={poliza}
                clientData={clientData}
                initialData={initialData}
                
                onCancel={onClose}
                onSuccess={handleSuccess}
            />
        </div>

        {/* NOTA: No necesitamos footer aquí porque SiniestroFormEditor ya incluye los botones de acción */}

      </div>
    </div>,
    document.body
  );
};

export default ModalSiniestro;